// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__DL320","title":"styles_title__KEpTA","description":"styles_description__FH0A4"};